import styled from 'styled-components';
import { media } from 'common/responsive';

const MobileImage = styled.img`
  object-fit: cover;
  height: 200px;
  width: 100%;

  ${media.tablet`
    height:350px;
  `};
`;

export default MobileImage;



// WEBPACK FOOTER //
// ./src/pages/Blog/LatestArticle/MobileImage.jsx